import { ReactNode } from "react"
import { Grid, Stack } from "@mui/material"
import { MRT_FullScreenToggleButton, MRT_TableInstance } from "material-react-table"
import { makeStyles } from "tss-react/mui"
import { StandardToggleGlobalFilterButton } from "./StandardToggleGlobalFilterButton"

const useStyles = makeStyles()(() => ({
    container: {
        width: "auto",
        padding: "1rem",
    },
    containerRight: {
        paddingLeft: ".5rem",
    },
}))

interface BaseTableFilterProps {
    variant: "left" | "right"
    showGlobalFilterButton?: boolean
    showFullScreenToggleButton?: boolean
    children?: ReactNode
}
interface LeftTableFilterProps extends BaseTableFilterProps {
    variant: "left"
    stackClassName?: string
    table?: never
}

interface RightTableFilterProps<TData extends Record<string, any>> extends BaseTableFilterProps {
    variant: "right"
    stackClassName?: string
    table: MRT_TableInstance<TData>
}

type TableFilterProps<TData extends Record<string, any>> = LeftTableFilterProps | RightTableFilterProps<TData>

export function StandardTableFilter<TData extends Record<string, any>>({
    variant,
    table,
    children,
    stackClassName,
    showGlobalFilterButton = true,
    showFullScreenToggleButton = true,
}: TableFilterProps<TData>) {
    const { classes, cx } = useStyles()

    return (
        <Grid
            container
            flexWrap="nowrap"
            gap={2}
            className={cx(classes.container, variant === "right" && classes.containerRight)}
        >
            {variant === "left" && (
                <Stack direction="row" flexWrap={{ xs: "wrap", sm: "nowrap" }} gap={2} className={stackClassName}>
                    {children}
                </Stack>
            )}

            {variant === "right" && (
                <Stack direction="row" spacing={1} className={stackClassName}>
                    {children}
                    {showGlobalFilterButton && <StandardToggleGlobalFilterButton table={table} />}
                    {showFullScreenToggleButton && <MRT_FullScreenToggleButton table={table} />}
                </Stack>
            )}
        </Grid>
    )
}
